import { RefreshCw } from "lucide-react"

interface Props {
  onClick: () => void
  className?: string
}

const RefetchButton = ({ onClick, className = "" }: Props) => (
  <button
    tabIndex={0}
    className={`flex items-center text-primary-400 font-medium cursor-pointer select-none ${className}`}
    onClick={onClick}
    aria-label="Refresh to load recent activity"
  >
    <RefreshCw size={20} />
  </button>
)

export default RefetchButton
